// CSS custom property names for brand settings
export const BRANDING_VARS = {
  brandColor: "--brand-color",
  buttonBrandColor: "--button-brand-color",
  buttonBrandColorHover: "--button-brand-color-hover",
  buttonBrandColorActive: "--button-brand-color-active",
  buttonBrandColorSubtleHover: "--button-brand-color-subtle-hover",
  buttonBrandRadius: "--button-brand-radius",
  inputBrandRadius: "--input-brand-radius",
} as const;
